module.exports = __webpack_public_path__ + "static/media/how-rewards-work-step-2.086eded1.jpg";